import { CommonNS } from "../../../../../../Common/CommonNS.js";
export const addEl = (self, el) => {
  self._checkNoProcessingTask();
  const working_layer_el = self._getWorkingLayerElThrowable();
  const stroke_sync = self._getStrokeSyncThrowable();
  if (!(el instanceof self._window.SVGGraphicsElement)) {
    throw new Error(`엘리먼트가 SVGGraphicsElement 가 아닙니다.`);
  }
  const graphics_el = el;
  self._transform_manipulator.initTransform(graphics_el);
  working_layer_el.appendChild(graphics_el);
  try {
    stroke_sync.sync();
  } catch (error) {
    CommonNS.UtilNS.tryNoop(() => working_layer_el.removeChild(graphics_el));
    error.message = `엘리먼트를 추가하는 데 실패했습니다. : ${error.message}`;
    throw error;
  }
  working_layer_el.dispatchEvent(
    new CustomEvent(`@mp/sticker-editor/add`, {
      bubbles: true,
      cancelable: true,
      composed: false,
      detail: {
        el: graphics_el,
      },
    })
  );
};
